import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const PANEL_AUTOPSIA_URL = `${API_BASE_URL}/PanelAutopsia`;

/**
 * El back devuelve el panel como el JSON crudo que quedó en S3 y manda los metadatos
 * de la corrida en cabeceras, para que el contrato del panel pueda crecer sin tocarlo.
 * Acá se juntan las dos cosas en un solo objeto.
 */
const armarRespuesta = (response) => ({
  panel: response.data,
  meta: {
    hash: response.headers['x-panel-hash'] ?? null,
    schemaVersion: response.headers['x-panel-schema-version'] ?? null,
    fecha: response.headers['x-panel-fecha'] ?? null,
  },
});

/** Corridas disponibles, de la más reciente a la más antigua. Alimenta el selector de fecha. */
export const listarPaneles = async (limite = 30) => {
  const response = await api.get(PANEL_AUTOPSIA_URL, { params: { limite } });
  return Array.isArray(response.data) ? response.data : [];
};

/** Último panel generado. Es con el que abre la pantalla. */
export const obtenerUltimoPanel = async () => {
  const response = await api.get(`${PANEL_AUTOPSIA_URL}/ultimo`);
  return armarRespuesta(response);
};

/** Panel de una corrida puntual, identificada por su hash. */
export const obtenerPanelPorHash = async (hash) => {
  const response = await api.get(`${PANEL_AUTOPSIA_URL}/${hash}`);
  return armarRespuesta(response);
};

/**
 * Versión del contrato que esta pantalla sabe leer. Los paneles en S3 son inmutables:
 * el histórico conserva la versión con que se generó, así que siempre van a convivir
 * varias. Se compara solo la parte mayor porque una menor superior es aditiva.
 */
export const CONTRATO_SOPORTADO = '2';

export const entiendeVersion = (schemaVersion) => {
  if (!schemaVersion) return true; // sin dato, se intenta igual
  return String(schemaVersion).split('.')[0] === CONTRATO_SOPORTADO;
};
